module.exports = __webpack_public_path__ + "static/gallery44-65e310b9d17250cb8f03a3af039b6692.png";